/* eslint-disable react/jsx-props-no-spreading */
import React from 'react'
import {
    Create,
    Edit,
    required,
    SimpleForm,
    TextInput,
    useNotify,
    useRefresh,
    useRedirect,
} from 'react-admin'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import BackButton from '../../components/BackButton'

import Title from '../../components/Title/Title'
import '../style.css'
import CustomValidater from '../../components/Utility/Validater'

const CountryComponent = (props) => {
    const user = useSelector((state) => state.auth)
    const { isEdit, title, record } = props
    const userData = {
        created_by: user.description,
        modified_by: user.description,
    }

    return (
        <SimpleForm
            validate={(values) => CustomValidater(values, props)}
            style={{ width: '100%' }}
            {...{ ...props, record: { ...record, ...userData } }}
            variant="outlined"
            warnWhenUnsavedChanges
            initialValues={userData}
        >
            <Title title={title} />
            <div className="container">
                <TextInput
                    style={{ display: 'flex', flex: 1 }}
                    variant="outlined"
                    label="Code"
                    source="code"
                    validate={[required()]}
                    disabled={isEdit}
                />
            </div>
            <div className="container">
                <TextInput
                    style={{ display: 'flex', flex: 1 }}
                    variant="outlined"
                    label="Description"
                    source="description"
                    validate={required()}
                />
            </div>
            <div className="container">
                <TextInput
                    style={{ display: 'flex', flex: 0.49 }}
                    variant="outlined"
                    disabled
                    label="Created By"
                    source="created_by"
                    validate={required()}
                />
                <TextInput
                    style={{ display: 'flex', flex: 0.49 }}
                    variant="outlined"
                    disabled
                    label="Modified By"
                    source="modified_by"
                    validate={required()}
                />
            </div>
        </SimpleForm>
    )
}

export default function CreateCountry(props) {
    const notify = useNotify()
    const refresh = useRefresh()
    const { isEdit } = props
    const redirect = useRedirect()
    const onSuccess = () => {
        notify(`Changes saved`, { type: 'success' })
        redirect('/PY_CountryTAB')
        refresh()
    }
    if (isEdit)
        return (
            <>
                <BackButton path="/PY_CountryTAB" />
                <Edit {...props} undoable={false}>
                    <CountryComponent title="Edit Country" isEdit />
                </Edit>
            </>
        )
    return (
        <>
            <BackButton path="/PY_CountryTAB" />
            <Create onSuccess={onSuccess} {...props}>
                <CountryComponent title="Create Country" isEdit={false} />
            </Create>
        </>
    )
}

CreateCountry.propTypes = {
    isEdit: PropTypes.bool.isRequired,
}

CountryComponent.propTypes = {
    isEdit: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    record: PropTypes.objectOf(PropTypes.any).isRequired,
}
